// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane {
  padding: 0em;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  min-width: 350px;
  height: 100vh;
  background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/core/tabs/tab/tab.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iDAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AACJ","sourcesContent":[".pane{\n    padding:0em;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    min-width:350px;\n    height: 100vh;\n    background: #fff;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
